/** @format */

const users = {
    users_list_add_csv_add_icon: "/assets/images/svg/users/ajout-csv.svg",
    users_list_add_quick_add_icon: "/assets/images/svg/users/ajout-rapide.svg",
    users_list_add_standard_add_icon: "/assets/images/svg/users/ajout-standard.svg",

    // Action
    users_participant_action_id: "/assets/images/svg/users/action-id.svg",
    users_participant_action_invite: "/assets/images/svg/users/action-invite.svg",
    users_participant_action_group: "/assets/images/svg/users/action-group.svg",
    users_participant_action_account: "/assets/images/svg/users/action-account.svg",
    users_participant_action_inbox: "/assets/images/svg/users/action-inbox.svg",
    users_participant_action_delete: "/assets/images/svg/users/action-delete.svg",
    users_participant_action_pencil: "/assets/images/svg/users/action-pencil.svg",
    users_participant_action_cached: "/assets/images/svg/users/action-cached.svg",
    users_participant_action_account_star: "/assets/images/svg/users/action-account-star.svg",
    users_participant_action_archive: "/assets/images/svg/users/action-inbox.svg"
}

export default users
